import { Modal, ModalCloseButton, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { Dispatch, SetStateAction, useState } from 'react';

export const DeleteField = ({
  handleDeleteField,
  isDeleteModalOpen,
  setIsDeleteModalOpen,
}: {
  handleDeleteField: (flag: boolean) => void;
  isDeleteModalOpen: boolean;
  setIsDeleteModalOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  return (
    <Modal
      isOpen={isDeleteModalOpen}
      onClose={() => {
        setIsDeleteModalOpen(false);
      }}
    >
      <ModalOverlay />
      <ModalContent
        style={{
          maxWidth: '42rem',
          padding: '28px',
          marginTop: '20rem',
          borderRadius: '8px',
        }}
      >
        <ModalCloseButton />
        <p className="mb-16 text-lg font-medium text-gray-999"> Delete field? </p>
        <p className="mb-32 text-sm text-gray-999">All tasks with this field will be affected.</p>
        <div className="flex justify-end">
          <button
            onClick={() => {
              setIsDeleteModalOpen(false);
            }}
            className="border-blue-500 text-blue-500 border rounded-sm px-24 py-13 mr-8"
          >
            Cancel
          </button>
          <button
            className="border-red-700 text-red-700 border rounded-sm px-24 py-13"
            onClick={() => {
              handleDeleteField(true);
            }}
          >
            Delete field
          </button>
        </div>
      </ModalContent>
    </Modal>
  );
};
